export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.tooltip)+'" role="tooltip"> <div class="'+(props.styles.tooltipInner)+'" data-hook="tooltipInner"></div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/core/tooltip/templates/tooltip.dot
// module id = 196
// module chunks = 0 1 2 3 4